/* Project Import will be here */
import * as actions from '../actions/lastSavedPunches.Action';
/* Project Import will be here */

/* Const,Let & Var will be here */
const initialState = {
    punches: {
        lastStartTime: "",
        lastEndTime: "",
        lastLunchStartTime: "",
        lastLunchEndTime: "",
    }
};

/* Const,Let & Var will be here */
export default function (state = initialState, action) {
    switch (action.type) {
        case actions.LAST_SAVED_PUNCHES:
            return {
                ...state,
                punches: {
                    ...state.timeCardData,
                    lastStartTime: action.lastStartTime,
                    lastEndTime: action.lastEndTime,
                    lastLunchStartTime: action.lastLunchStartTime,
                    lastLunchEndTime: action.lastLunchEndTime,
                }
            };

        default:
            return state;
    }
}